import { markRaw } from 'vue'
import FloatingBannerView from './FloatingBannerView.vue'
import { DEFAULT_FLOATING_BANNER_ITEM } from './constants'
import schema from './schema'
import uiSchema from './ui-schema'
import {
  DEFAULT_COLOR_PRIMARY,
  DEFAULT_COLOR_WHITE,
} from '~/components/page-editor/constants'

export default {
  viewComponent: markRaw(FloatingBannerView),
  editorSchema: schema,
  editorUISchema: uiSchema,
  editorData: {
    width: 320,
    backgroundColor: DEFAULT_COLOR_PRIMARY,
    borderColor: DEFAULT_COLOR_WHITE,
    borderWidth: 2,
    borderRadius: 20,
    paddingLeft: 5,
    paddingRight: 5,
    paddingVertical: 5,
    itemsGap: 8,
    items: [{ ...DEFAULT_FLOATING_BANNER_ITEM }],
  },
}
